export const twitterAnalyticsEvents = {
	SIGNUP_REQUEST: 'tw-ontba-oqw41',
	CREDITS_OVER: 'tw-ontba-oqw44',
	GENERATE_BUTTON: 'tw-ontba-oqw43',
	BEGIN_CHECKOUT: 'tw-ontba-oqw45',
	PURCHASE_SUCCESSFULL: 'tw-ontba-oqw47',
};
